export default __webpack_public_path__ + "static/media/property_752.419f41da.png";